<cst-toolbar
  ><h3>
    <a [routerLink]="['/administration']" i18n="@@Admin_Header"
      >Administration</a
    >
    > {{ header }}
  </h3></cst-toolbar
>

<cst-tile-grid
  mode="iconAndLabel"
  [fetchDataCallback]="onFetchData.bind(this)"
  [canTileClick]="canTileClick.bind(this)"
  [tileClick]="onTileClick.bind(this)"
  noItemsText=""
>
</cst-tile-grid>
